/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FoldersControllerCreateMutationRequest, FoldersControllerCreateMutationResponse, FoldersControllerCreate400, FoldersControllerCreate401, FoldersControllerCreate403 } from "../../models/foldersController/FoldersControllerCreate";

function getFoldersControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/folders` as const }  
  return res
}

/**
 * @summary Create a new folder
 * {@link /api/v1/folders}
 */
export async function foldersControllerCreate(data?: FoldersControllerCreateMutationRequest, config: Partial<RequestConfig<FoldersControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<FoldersControllerCreateMutationResponse, ResponseErrorConfig<FoldersControllerCreate400 | FoldersControllerCreate401 | FoldersControllerCreate403>, FoldersControllerCreateMutationRequest>({ method : "POST", url : getFoldersControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}